const routes = Object.freeze({
    ROOT: '/',
    WELCOME: '/welcome',
    WELCOME_ECR_ID: '/welcome/:ecrId?',
    ERROR_PAGE: '/error-page',
    LOGIN_CALLBACK: '/callback',
    KEYCLOAK_CALLBACK: '/authentication/login-callback',
    LOGIN: '/login',
    LOGOUT: '/logout',
    REGISTER: '/register',
});
export default routes;
